import PedagogicalEditorController from './pedagogicalEditorController';
import './pedagogicalEditor.scss';

const pedagogicalEditorComponent = {
    template: require('./pedagogicalEditorView.html'),
    controller: PedagogicalEditorController,
};

export default pedagogicalEditorComponent;



// WEBPACK FOOTER //
// ./src/app/pages/manageSkills/pedagogical/pedagogicalEditorComponent.js